import React from "react";
import PublicContext from "../contexts/PublicContext";

const PrivacyPolicyPage = () => {
	return (
		<PublicContext>
			<div className="container mx-auto p-8 bg-white rounded-xl shadow-xl">
				<h1 className="text-3xl font-bold text-blue-700 mb-6">Informativa sulla Privacy</h1>

				<p className="text-lg mb-4">
					Questa informativa descrive come vengono raccolti, utilizzati e protetti i tuoi
					dati personali quando utilizzi il sistema SIEC - Sistema Informativo Emergenze
					Comunali Atri.
				</p>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						1. Titolare del trattamento
					</h2>
					<p>
						Il titolare del trattamento dei dati è Protezione Civile ANA Sezione Abruzzi
						- Gruppo di Atri. Per informazioni, puoi contattarci via email a
						<a
							href="mailto:info@ProtezioneCivileANAtri.it"
							className="text-blue-500 underline ml-1"
						>
							info@ProtezioneCivileANAtri.it
						</a>
						.
					</p>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">2. Dati raccolti</h2>
					<ul className="list-disc pl-6 space-y-2">
						<li>
							<strong>Dati di contatto:</strong> Nome, cognome, email, e numero di
							telefono.
						</li>
						<li>
							<strong>Dati di localizzazione:</strong> Coordinate GPS opzionali
							fornite durante l'invio di segnalazioni.
						</li>
						<li>
							<strong>Contenuto della segnalazione:</strong> Informazioni condivise
							volontariamente dall'utente.
						</li>
					</ul>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						3. Finalità del trattamento
					</h2>
					<p>I dati raccolti vengono utilizzati esclusivamente per:</p>
					<ul className="list-disc pl-6 space-y-2">
						<li>
							Gestire segnalazioni di emergenza e problemi relativi alla sicurezza.
						</li>
						<li>Fornire aggiornamenti agli utenti su eventuali azioni intraprese.</li>
						<li>Analizzare i dati per migliorare i servizi forniti.</li>
					</ul>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						4. Condivisione dei dati
					</h2>
					<p>
						I dati personali non verranno mai venduti o condivisi con terze parti non
						autorizzate. Tuttavia, potrebbero essere condivisi con autorità competenti o
						enti coinvolti nella gestione delle emergenze, ove necessario.
					</p>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						5. Conservazione dei dati
					</h2>
					<p>
						I dati personali saranno conservati per il tempo strettamente necessario a
						gestire le segnalazioni e a rispettare gli obblighi legali.
					</p>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						6. Diritti dell'utente
					</h2>
					<ul className="list-disc pl-6 space-y-2">
						<li>Accedere ai propri dati personali e richiedere una copia.</li>
						<li>Correggere eventuali inesattezze nei propri dati.</li>
						<li>Cancellare i propri dati, ove applicabile.</li>
						<li>Limitare o opporsi al trattamento dei propri dati personali.</li>
					</ul>
					<p>Per esercitare questi diritti, contattaci all'email indicata sopra.</p>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						7. Sicurezza dei dati
					</h2>
					<p>
						Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi
						dati personali da accessi non autorizzati, perdite o distruzioni.
					</p>
				</section>

				<section className="mb-6">
					<h2 className="text-2xl font-semibold text-blue-600 mb-4">
						8. Modifiche alla privacy policy
					</h2>
					<p>
						Questa informativa potrebbe essere aggiornata periodicamente. Ti invitiamo a
						consultarla regolarmente per rimanere informato sulle modalità di
						trattamento dei tuoi dati.
					</p>
				</section>
			</div>
		</PublicContext>
	);
};

export default PrivacyPolicyPage;
